import axios from 'axios'
import { isObject, noop } from './sso/lang'
import cookies from 'js-cookie'
import { SUCCESS, UNAUTHORIZED } from './sso/constants'
import { cookieOptions } from "@/constants/auth";

const JSON_HEADER = 'application/json;charset=UTF-8'
const FILE_HEADER = 'multipart/form-data'

let IS_FILE = false

axios.defaults.withCredentials = true
const request = axios.create({
	timeout: 15000 // 请求超时时间，
})
let setGloballHeader = noop
let setCustomHeader = noop

let redirectCallback = null

const _handleCustomHeader = ops => {
	if (ops) {
		setCustomHeader = ops.setHeader ? ops.setHeader() : noop
	}
}

// request拦截器
request.interceptors.request.use(
	config => {
		config.headers['Content-Type'] = IS_FILE ? FILE_HEADER : JSON_HEADER
		config.headers['accept-language'] = cookies.get('langAlbum') || 'zh-cn'
		config = setGloballHeader(config)
		return setCustomHeader(config)
	},
	error => {
		Promise.reject(error)
	}
)

// respone拦截器
request.interceptors.response.use(
	response => {
		if (response.status === 200) {
			return response.data
		}
		return {}
	},
	error => {
		const res = error.response
		if (res.status == 302) {
			return res.data
		}
		if (res) {
			if (res.status === UNAUTHORIZED) {
				if (redirectCallback) {
					try {
						cookieOptions.map(item => {
							cookies.remove('userId', item)
							cookies.remove('token', item)
							cookies.remove('spaceId', item)
						})
					} catch (error) {
					}
					redirectCallback()
					return
				}
			} else {
				if (res.data?.code === UNAUTHORIZED) {
				} else {
					console.log(error)
					res.data?.message && message?.error(res.data?.message)
					return Promise.reject(new Error())
				}
			}
		} else {
			return Promise.reject(new Error())
		}
		return {}
	}
)

export const setRedirectCallback = callback => {
    redirectCallback = callback
}

export const post = function (ops) {
	IS_FILE = false
	_handleCustomHeader(ops)
	return request({
		method: 'post',
		...ops
	})
}
export const put = function (ops) {
	IS_FILE = false
	_handleCustomHeader(ops)
	return request({
		method: 'put',
		...ops
	})
}
export const get = function (ops) {
	IS_FILE = false
	_handleCustomHeader(ops)
	return request({
		method: 'get',
		...ops
	})
}
export const upload = function (ops) {
	IS_FILE = true
	_handleCustomHeader(ops)
	return request({
		method: 'post',
		...ops
	})
}

export const setCommonHeader = register => {
	setGloballHeader = register || noop
}
